import { render } from "./self-enroll.vue?vue&type=template&id=5187f4d2&lang=pug"
import script from "./self-enroll.vue?vue&type=script&lang=js"
export * from "./self-enroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__